import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { Permission } from '@modules/permissions/utils';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { ReportType } from '../enums';
import type { IReportOptionsResponse } from '../types';
import { REPORT_OPTIONS_API_URL, REPORT_OPTIONS_QUERY } from '../constants';

export default function useReportOptionsQuery(
  reportType: Ref<ReportType>,
  permission: Ref<Permission>,
): IContextQueryResult<IReportOptionsResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery({
    queryKey: [REPORT_OPTIONS_QUERY, reportType],
    queryFn: ({ signal }) => fetchGet<IReportOptionsResponse>(REPORT_OPTIONS_API_URL, {
      signal,
      urlParams: {
        reportType: reportType.value,
      },
      permission: permission.value,
    }),
  });
}
